"use strict";
(self["webpackChunkbranch_basics"] = self["webpackChunkbranch_basics"] || []).push([[7040],{

/***/ 7040:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Popup)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function Popup({ wrapper }) {
  let settings = {
    popUp: wrapper,

    overlay: ".overlay",
    popUpClose: '[data-hook="popup-close"]',
    popUpSubmit: '[data-hook="wellness-popup-submit"]'
  }

  ;(function init() {
    
    // handleOnLoad();
    // initializeEventListeners();
  })()

  
  function handleOnLoad() {
    let popupHasBeenShown = localStorage.getItem('blog-popup');
    if(!popupHasBeenShown){
      if (window.location.href.includes("recurring/portal")) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.popUp).css('display', 'none !important');
      } else{
        window.setTimeout(function(){
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.overlay).addClass('active popup-overlay');
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.popUp).addClass('active');
        }, 7000);
      }

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.overlay).css('top', 0);

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('scroll', function(){
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.overlay).css('top', 0);
      });

    } else {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.popUp).css('display', 'none !important');
    }
  }


  function initializeEventListeners() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.overlay).click(closePopUp);
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.popUpClose).click(closePopUp);
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.popUpSubmit).click(submitPopUp);
  }


  function closePopUp() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.overlay).removeClass('active');
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.overlay).removeClass('popup-overlay');
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.popUp).removeClass('active');
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.popUp).css('display', 'none !important');

    let date = new Date();

    date.setTime(date.getTime()+(365*24*60*60*1000))

    document.cookie = "popup=true; expires=" + date.toGMTString();
    localStorage.setItem('blog-popup', true);
  }


  function submitPopUp() {
    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()('#drip-email').val() != "") {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.overlay).removeClass('active');
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.overlay).removeClass('popup-overlay');
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.popUp).removeClass('active');
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.popUp).css('display', 'none !important');

      let date = new Date();

      date.setTime(date.getTime()+(365*24*60*60*1000))

      document.cookie = "popup=true; expires=" + date.toGMTString();
      localStorage.setItem('blog-popup', true);
    }
  }
  

};

/***/ })

}]);